module.exports = __webpack_public_path__ + "img/ic_chevron-left.91aa3db0.svg";